const save = {
  props: {
    value: {
      type: Object,
      required: false
    },
    id: {
      type: Number,
      default: 0
    },
    dialog: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected: { ...this.value },
      closeTimeout: {},
      saveSuggest: {
        first: true,
        changed: false
      }
    }
  },
  watch: {
    id () {
      if (this.$refs.SaveForm) this.$refs.SaveForm.resetValidation()
    },
    selected: {
      deep: true,
      handler (newVal) {
        if (this.dialog) {
          if (this.saveSuggest.first) {
            this.saveSuggest.first = false
          } else if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
            this.saveSuggest.changed = true
          }
          this.$forceUpdate()
        }
      }
    },
    dialog (newVal) {
      if (newVal) {
        this.selected = { ...this.value }
      } else {
        this.saveSuggest.first = true
        this.saveSuggest.changed = false
      }
    },
    value () {
      this.selected = { ...this.value }
      this.saveSuggest.first = true
      this.saveSuggest.changed = false
      this.$forceUpdate()
    },
    'socketInfo.doneResponse' (val) {
      if (val) {
        clearTimeout(this.closeTimeout)
        this.closeTimeout = setTimeout(function () {
          if (this.selected) this.$emit('input', this.selected)
          this.$emit('closed', true)
        }.bind(this), 99)
      }
    }
  },
  methods: {
    async closeDialog (closed) {
      if (closed && this.saveSuggest.changed) {
        var rootRoute = (this.routerPath.page ? this.routerPath.page : this.routerPath.root)
        closed = await this.$root.$dialog.confirm({
          text: this.lang.confirm.saveAlert((this.getTitle_ ? this.getTitle_.title_s : this.lang[rootRoute].title_s)),
          title: this.lang.confirm.title,
          waitForResult: true
        })
      }
      if (closed) {
        if (typeof this.$refs.SaveForm !== 'undefined') this.$refs.SaveForm.resetValidation()
        this.saveSuggest.changed = false
        this.saveSuggest.first = true
        this.$emit('closed', true)
      } else {
        this.$emit('closed', false)
      }
    }
  }
}

export default save
